import React from 'react';
import assign from 'object-assign';
import PropTypes from 'prop-types';

import Form from '../Common/Form.react';
import LinearProgress from 'material-ui/LinearProgress';
import { Card, CardText } from 'material-ui/Card';
//business logic:
import BuildForm from '../Common/BuildDynamicForm';

import FilterActions from '../../actions/FilterActionCreator';
import FilterStore from '../../stores/FilterStore';
import UserActions from '../../actions/UserActionCreator';
import AttributeStore from '../../stores/AttributeStore';

import DepartmentStore from '../../stores/DepartmentStore';
import DepartmentActions from '../../actions/DepartmentActionCreator';
import UserGroupStore from '../../stores/UserGroupStore';
import GroupActions from '../../actions/UserGroupActionCreator';
import SkillStore from '../../stores/SkillStore';
import SkillActions from '../../actions/SkillActionCreator';

const defined = function(e) { return e !== undefined; };

const FilterForm = React.createClass({

    getInitialState: function () {
        const isEdit = (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/));
        return {
            isEdit: isEdit,
            redirectTo: (isEdit ? '/dashboard/filter/' + this.props.routeParams.id : '/dashboard/filters'),
            details: {
                id: '',
                name: '',
                description: '',
                filterCriteria: {
                    department: [],
                    userGroup: [],
                }
            },
            filters: [
                {  field: 'department', label: 'In any of these departments',    store: DepartmentStore, getAll: DepartmentActions.getAll},
                {  field: 'userGroup',  label: 'In any of these groups',   store: UserGroupStore,  getAll: GroupActions.getAll},
                {  field: 'skill',      label: 'Has any of these skills',         store: SkillStore,      getAll: SkillActions.getAll},
                {  field: 'notSkill',   label: 'Does not have any of these skills', store: SkillStore,      getAll: SkillActions.getAll}
            ],
            dataSource: {
                department: [],
                userGroup:  []
            },
            attributes: []
        }
    },

    componentDidMount: function() {
        FilterStore.addChangeListener(this._onChange);
        if(this.state.isEdit) {
            FilterActions.getById(this.props.routeParams.id);
        }
        this.listeners = [];
        this.state.filters.forEach((filter) => {
            const listener = filter.store.addListener(this._onDataSourceChange.bind(this, filter));
            this.listeners.push(listener);
            filter.getAll({limit: 0});
        });

        this.attributeListener = AttributeStore.addListener(this.onAttributeChange);
        UserActions.getActiveAttributes();

    },

    componentWillUnmount: function() {
        FilterStore.removeChangeListener(this._onChange);
        this.attributeListener.remove();
        this.listeners.forEach(listener => listener.remove());
    },

    render: function () {

        const formTitle  = (this.state.isEdit ? this.state.details.name  : 'New filter');
        let fieldList = [
            {
                label: 'Name',
                props: {
                    validations: "minLength:2,maxLength:80",
                    validationError: "Numbers and letters only - minimum 2",
                    required: true,
                }
            },
            {
                label: 'Description',
                props: {
                    validations: "maxLength:120",
                    validationError: "Numbers and letters only",
                    multiLine: true,
                }
            },
        ];
        let loading = (this.state.isEdit && this.state.details.id === '');

        if (!loading) {
            this.state.filters.forEach(function(filter) {
                if (this.state.dataSource[filter.field] === undefined) {
                    loading = true;
                } else {
                    let fieldValue;
                    if (this.state.details.filterCriteria !== undefined && this.state.details.filterCriteria[filter.field] !== undefined) {
                        fieldValue = this.state.details.filterCriteria[filter.field].filter((fv) => (
                            this.state.dataSource[filter.field].find((f) => (f !== undefined && f.id === fv)) !== undefined)
                        );
                    } else {
                        fieldValue = [];
                    }
                    fieldList.push({
                        name:  filter.field,
                        label: filter.label,
                        type: 'autocomplete',
                        dataSource: this.state.dataSource[filter.field],
                        onSelect: this._onSelectItemCreator(filter.field),
                        deleteItem: this._onDeleteItemCreator(filter.field),
                        props: {
                            value: fieldValue,
                        }
                    });
                }
            }, this);

            this.state.attributes.forEach(({code, name, typeName, values = []}) => {
                const fieldType = typeName === 'option' ? 'select' : 'textfield';
                fieldList.push({
                    name:  code,
                    label: name,
                    type: fieldType,
                    props: {
                        value: this.state.isEdit ? this.getAttributeValue(code) : '',
                        onChange: (e, value) => this.setAttributeValue(code, value)
                    },
                    children: ['', '--Empty--' , ...values]

                });
            })
        }

        const fields = BuildForm(fieldList, this.state.details, this);
        const progressBar = (loading ? <LinearProgress mode="indeterminate" /> : null);

        return(
            <Form
                title={formTitle}
                onSave={this.submitForm}
                redirectTo={this.state.redirectTo}
            >
                <Card className="cent-card">
                    <CardText>
                {fields}
                    </CardText>
                    {progressBar}
                </Card>
            </Form>
      );
    },

    submitForm: function (model) {
        model.filterCriteria = {};
        for (let field in this.state.details.filterCriteria) if (this.state.details.filterCriteria.hasOwnProperty(field)) {
            if (this.state.details.filterCriteria[field] instanceof Array && this.state.details.filterCriteria[field].length > 0) {
                model.filterCriteria[field] = this.state.details.filterCriteria[field].filter(defined);
            }
        }

        model.filterCriteria['attributes'] = [];
        model.filterCriteria['emptyAttributes'] = [];
        this.state.attributes.forEach(({code}) => {
            if (model[code] === '--Empty--') {
                model.filterCriteria['emptyAttributes'].push(code);
            } else if (model[code] !== '') {
                model.filterCriteria['attributes'].push({code, value: model[code].split('|')});
            }
        });

        if (this.state.isEdit) {
            return FilterActions.update(this.props.routeParams.id, model);
        } else {
            return FilterActions.save(model);
        }
    },

    _onChange: function() {
        let details = FilterStore.getById(this.props.routeParams.id);
        if (details !== undefined) {
            // make sure we get arrays instead of plain values:
            for (var i in details.filterCriteria) if (details.filterCriteria.hasOwnProperty(i)) {
                if (details.filterCriteria[i] === undefined || details.filterCriteria[i] === null) {
                    details.filterCriteria[i] = [];
                } else if (!(details.filterCriteria[i] instanceof Array)) {
                    details.filterCriteria[i] = [details.filterCriteria[i]];
                }
            }
            this.setState(assign({}, this.state, { details: details}));
        }
    },

    _onDataSourceChange: function(filter) {
        const source = filter.store.getAll();
        if (source !== undefined) {
            if (this.context.auth.isRoot() && filter.field === 'department') {
                source.forEach(({name, organisation}, i) => { source[i].name = `${name} (${organisation})`; });
            }
            const dataSource = assign({}, this.state.dataSource, {[filter.field]: source});
            this.setState({dataSource});
        }
    },

    _onSelectItemCreator: function(field) {
        let self = this;
        return function(element) {
            if (self.state.details.filterCriteria[field] === undefined) {
                let state = self.state;
                state.details.filterCriteria[field] = [element.id];
                self.setState(state);
            } else {
                let i = self.state.details.filterCriteria[field].findIndex(function(e) { return e !== undefined && e == element.id; } );
                if (i < 0) {
                    let state = self.state;
                    state.details.filterCriteria[field].push(element.id);
                    self.setState(state);
                }
            }
            return true;
        }
    },

    _onDeleteItemCreator: function(field) {
        let self = this;
        return function(elementId) {
            let i = self.state.details.filterCriteria[field].findIndex(function(e) { return e !== undefined && e == elementId; } );
            if (i >= 0) {
                let state = self.state;
                delete state.details.filterCriteria[field][i];
                self.setState(state);
            }
        }
    },

    onAttributeChange: function() {
        const attributes = AttributeStore.getAll();
        if (attributes !== undefined) {
            this.setState({attributes});
        }
    },

    getAttributeValue: function(code) {
        let value = '';
        if (this.state.details.filterCriteria.attributes !== undefined) {
            const attribute = this.state.details.filterCriteria.attributes.find((a) => {return a !== undefined && a.code === code;});
            if (!!attribute) {
                value = Array.isArray(attribute.value) ? attribute.value.join('|') : attribute.value;
            }
        } if (!value && !!this.state.details.filterCriteria.emptyAttributes && this.state.details.filterCriteria.emptyAttributes.includes(code)) {
            value = '--Empty--';
        }
        return value;
    },

    setAttributeValue: function (code, value) {
        if (this.state.details.filterCriteria.attributes === undefined) { return; } //guard

        const { attributes, emptyAttributes } = this.state.details.filterCriteria;
        let index = -1;
        if (!!emptyAttributes) {
            index = emptyAttributes.findIndex((e) => e === code);
        }
        this.setState({
            details: {
                ...this.state.details,
                filterCriteria: {
                    ...this.state.details.filterCriteria,
                    attributes: !!attributes.find((e) => e !== undefined && e.code === code)
                            ? attributes.map((e) => e.code !== code ? e : {code, value})
                            : [...attributes, {code, value}],
                    emptyAttributes: index < 0
                        ? emptyAttributes
                        : [
                            ...emptyAttributes.slice(0, index),
                            ...emptyAttributes.slice(index + 1, emptyAttributes.length)
                          ]
                }
            }
        });
    }
});

FilterForm.contextTypes = {
    auth:       PropTypes.object
};

export default FilterForm;
